import { Env } from "../../Models/Env";
import { EnvDetector } from "../EnvDetector";
import { Order } from "../../Models/Order";
import { EmailSender } from "./EmailSender";
import { INotifier } from "./INotifier";


export class Notifier implements INotifier
{
    constructor(private _emailSender: EmailSender, private _env: EnvDetector)
    { }

    private async Notify(email: string, message: string): Promise<void>
    {
        await this._emailSender.SendEmail(email, "specTeam.pl: Zmiana w zamówieniu", message);
    }

    public async NotifyOrderUpdate(order: Order): Promise<void>
    {
        const customerEmail = order.People.Items.find(x => x.Email.value != "")?.Email.value;
        if (customerEmail)
        {
            let origin = "";
            switch (this._env.Env)
            {
                case Env.Local:
                    origin = window.location.origin;
                    break;
                case Env.Stage:
                    origin = "https://new.orders.specteam.pl";
                    break;
                case Env.Prod:
                    origin = "https://shop.specteam.pl";
                    break;
            }

            await this.Notify(customerEmail, `Stan Twojego zamówienia #${order.ShortId} właśnie się zmienił - <a href="${origin}#order/${order.Id}" target="_blank">Sprawdź co się zmieniło</a>`);
        }
    }
}

